import React, { useEffect } from "react";
import { useForm, useWatch, Controller } from "react-hook-form";
import { Box, Grid } from "@mui/material";
import { isValid } from "date-fns";
import moment from "moment-timezone";
import { getUTCDateWithLocalTimezone, parseDateIntoUTC, formatDate, checkDateStringSatisfiesMask } from "../../utils/date.js";
import "react-intl";
import { DateInputMask } from "./DatePicker.config.js";
import { localizedDatePickerFooterSingleMode } from "./DatePickerFooterSingleMode.localize.js";
import { useDatePickerFooterSingleModeClasses } from "./DatePickerFooterSingleMode.style.js";
import { FormTextInputCleanable } from "./FormInput.js";
const DatePickerFooterSingleMode = ({ value, locale, onChange }) => {
  const { classes } = useDatePickerFooterSingleModeClasses();
  const inputMask = DateInputMask[locale] ?? "YYYY-MM-DD";
  const { control, setValue } = useForm({ defaultValues: { date: "" } });
  const watched = useWatch({ control });
  const parsedDate = getUTCDateWithLocalTimezone(moment(parseDateIntoUTC(watched.date, inputMask)));
  useEffect(() => {
    if (value?.getTime() !== parsedDate?.getTime()) {
      setValue("date", isValid(value) ? formatDate(value, "iso-date", false, false) : "");
    }
  }, [value]);
  useEffect(() => {
    if (isValid(parsedDate) && checkDateStringSatisfiesMask(watched.date, inputMask)) {
      onChange(parsedDate);
    }
  }, [watched.date]);
  return /* @__PURE__ */ React.createElement(Box, { mt: 1 }, /* @__PURE__ */ React.createElement(Grid, { container: true, spacing: 1 }, /* @__PURE__ */ React.createElement(Grid, { size: { xs: 12 } }, /* @__PURE__ */ React.createElement(
    Controller,
    {
      render: ({ field, fieldState }) => /* @__PURE__ */ React.createElement(
        FormTextInputCleanable,
        {
          className: classes.datePickerFooterSingleModeInput,
          key: field.name,
          value: field.value,
          onChange: field.onChange,
          clear: () => onChange(null),
          fieldState,
          placeholder: inputMask,
          label: localizedDatePickerFooterSingleMode.datePickerFooterSingleModeDateLabel
        }
      ),
      name: "date",
      control
    }
  ))));
};
export {
  DatePickerFooterSingleMode
};
//# sourceMappingURL=DatePickerFooterSingleMode.js.map
